import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { DropdownMonthList } from 'utils/Constant';
import { addSpaceEvery4, GetBookingType, GetPaymentType, money } from 'utils/helpers';
import Signature from '../assets/images/ownerSignature.png'

export const PaymentInvoiceService = async (data) => {
    let y = 20

    const doc = new jsPDF('p', 'mm', 'a4');
    const imgBase64 = await loadImgToBase64(Signature);
    // const img = await loadImage('/path/to/logo.png');

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('BUKTI PEMBAYARAN', 105, y, { align: 'center' });
    y = y + 6
    doc.text('DELALA KOST', 105, y, { align: 'center' });
    y = y + 6

    // Change to default font size and font wight
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    doc.text('Jl. Poncowolo Barat VIII No 507, Semarang ', 105, y, { align: 'center'});
    y = y + 4
    doc.text('Telp. 0822 2159 2417 ', 105, y, { align: 'center'});
    y = y + 6

    doc.setLineWidth(0.5); // Pengatur ketebalan garis dalam mm (opsional)
    doc.line(15, y, 195, y); // doc.line(startX, startY, endX, endY)

    y = y + 6

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.text('No Invoice        : ' + 'INV/' + moment(new Date()).format('MMYY') + '/' + String(data.paymentId), 15, y);
    y = y + 6
    doc.text('Tanggal            : ' + moment(data.paymentDate).format('DD MMM YYYY'), 15, y);
    y = y + 6
    doc.text('Status               : LUNAS' , 15, y);
    y = y + 12

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');

    doc.text('DATA PENGHUNI', 15, y);
    y = y + 8

    // Change to default font size and font wight
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.text('Nama                : ' + data.tenantName, 15, y);
    y = y + 6
    doc.text('Telp                  : ' + addSpaceEvery4(data.phone), 15, y);
    y = y + 6
    doc.text('No Kamar         : ' + data.roomNumber, 15, y);
    y = y + 12
    
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');

    doc.text('RINCIAN PEMBAYARAN', 15, y);
    y = y + 4

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.setLineWidth(0.5); // Pengatur ketebalan garis dalam mm (opsional)
    doc.line(15, y, 195, y); // doc.line(startX, startY, endX, endY)
    //doc.text('-------------------------------------------------------------------' + <hr />, 105, y, { align: 'center' });
    y = y + 6

    doc.text('Tipe Sewa                         : ' + GetBookingType(data.bookingType) , 15, y);
    y = y + 6

    doc.text('Tipe Bayar                        : ' + GetPaymentType(data.paymentType) , 15, y);
    y = y + 6
    
    // UNTUK BOOKING HARIAN DAN MINGGUAN
    if (data.bookingType === '1' || data.bookingType === '2') {
        doc.text('Tanggal Check In              : ' + moment(data.checkInDate).format('DD MMM YYYY') , 15, y);
        y = y + 6

        doc.text('Tanggal Check Out           : ' + moment(data.checkOutDate).format('DD MMM YYYY') , 15, y);
        y = y + 6

        if (data.bookingType === '1') {
            doc.text('Lama Sewa                       : ' + moment(data.checkOutDate).diff(moment(data.checkInDate), 'days') + ' Hari' , 15, y);
            y = y + 6
        }
    }

    // UNTUK BOOKING BULANAN
    if (data.bookingType === '3') {
        doc.text('Periode                             : ' + DropdownMonthList.find(x => x.value === data.paymentPeriodeMonth).label + ' ' + data.paymentPeriodeYear, 15, y);
        y = y + 6
    }

    doc.text('Jumlah Pembayaran         : Rp ' + money(data.amount) , 15, y);
    y = y + 6

    doc.text('Keterangan                       : ' + data.remark , 15, y);
    y = y + 6

    doc.setLineWidth(0.5); // Pengatur ketebalan garis dalam mm (opsional)
    doc.line(15, y, 195, y); // doc.line(startX, startY, endX, endY)
    //doc.text('-------------------------------------------------------------------' + <hr />, 105, y, { align: 'center' });
    y = y + 12

    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');

    doc.text('PEMBAYARAN LUNAS', 105, y, { align: 'center' });
    y = y + 8


    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    doc.text('Terima kasih telah melakukan pembayaran', 15, y);
    y = y + 4
    doc.text('Bukti pembayaran ini dibuat secara digital.', 15, y);
    y = y + 24

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.text('Semarang, ' + moment(data.paymentDate).format('DD MMMM YYYY'), 48, y, { align: 'center' });
    y = y + 2

    doc.addImage(imgBase64, 'PNG', 32, y, 30, 30);
    // doc.addImage(logoUrl, 'JPEG', 10, 10, 50, 50);
    y = y + 32

    doc.text('Natalia Marcella', 48, y, { align: 'center' });
    y = y + 28

    const tableBody = []
    // const tableBody = data.map((row) => [
    //     row.rowNumber,
    //     row.tenantName, 
    //     ...(bookingType === '' ? [GetBookingType(row.bookingType)] : []),
    //     //`${row.bankCode} \n${addSpaceEvery4(row.cardNumber)}`,
    //     moment(row.checkInDate).format('DD MMM YYYY'),
    //     moment(row.checkOutDate).format('DD MMM YYYY'),
    //     // moment(row.paymentDate).format('DD MMM YYYY'),
    //     'Rp ' + money(row.amount),
    //     GetPaymentType(row.paymentType),
    //     row.remark,
    // ]);

    autoTable(doc, {
        startY: y,
        head: [[
            // 'No',
            // 'Nama Tenant', 
            // ...(bookingType === '' ? ['Tipe Booking'] : []),
            // 'Tgl Check In',
            // 'Tgl Check Out',
            // //'Tgl Bayar',
            // 'Jumlah',
            // 'Tipe Pembayaran',
            // 'Remark',
        ]],
        body: tableBody,
        styles: {
            fontSize: 8,
            cellPadding: 1,
            lineWidth: 0.1,
            halign: 'center', // horizontal center
            valign: 'middle', // vertical center
            overflow: 'linebreak'
        },
        headStyles: {
            fillColor: [215, 215, 215],
            textColor: 0,
            halign: 'center',
            valign: 'middle',
            lineWidth: 0.2,
            lineColor: 0
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            lineWidth: 0.2,
            lineColor: 0
        },
        columnStyles: {
            // 2: {
            //     cellWidth: 34, // adjust as needed
            // }
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        margin: { top: 15, bottom: 10 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;

            // doc.setFontSize(8);
            // doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 5);
        },
    });

    let yPos = doc.lastAutoTable.finalY + 10;
    const pageHeight = doc.internal.pageSize.height;

    if (yPos + 20 > pageHeight) {
        doc.addPage();
        yPos = 20;
    }

    // Open on new tab
    doc.output('dataurlnewwindow');
}

const loadImgToBase64 = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        // img.crossOrigin = 'Anonymous'; // Un-comment jika gambar diambil dari URL domain lain

        img.onload = () => {
        const canvas = document.createElement('canvas');
        // Gunakan naturalWidth/Height agar ukuran tidak 0x0
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        // Ambil data Base64
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
        };

        img.onerror = (err) => reject(err);
        img.src = src;
    });
};